export default __webpack_public_path__ + "static/Transportation-705e53536f868106ddcb8165272d7a52.webp";